'use strict';

var $ = require('jquery'),
    formValidation = require('../components/formValidation'),
    createErrorNotification = require('../components/errorNotification'),
    cpfChecker = require('../register/register');

require('../components/spinner');

function updateQueryString(key, value, url) {
    if (!url) url = window.location.href;
    var re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi'),
        hash;

    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null) {
            return url.replace(re, '$1' + key + '=' + value + '$2$3');
        } else {
            hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        }
    } else {
        if (typeof value !== 'undefined' && value !== null) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?';
            hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        } else {
            return url;
        }
    }
}

function getQueryStringParam(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

module.exports = {
    login: function () {
        $('form.login').submit(function (e) {
            e.preventDefault();

            var form = $(this),
                bodyFromForm = form.parents('body'),
                url = form.attr('action');

            bodyFromForm.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    bodyFromForm.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                    } else {
                        $('form.login').trigger('login:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        bodyFromForm.spinner().stop();
                    }
                }
            });
            return false;
        });

        if($('#modal-warning-login').hasClass('modal-redirect')){
            $('.modal.modal-redirect').show();
        }
        $('#closeModal').on('click', function(){
            $('.modal.modal-redirect').hide();
            $('.modal-backdrop').remove();
        });
    },

    register: function () {
        cpfChecker = cpfChecker.cpfValidator(true);
        $('.registration').submit(function (e) {
            e.preventDefault();

            var form = $(this),
                bodyFromForm = form.parents('body'),
                url = form.attr('action');

            if (getQueryStringParam('checkoutRegistration', window.location.href)) {
                url = updateQueryString('checkoutRegistration', true, url);
            }

            if (!window.isCpfValidObj) {
                cpfChecker.showError();
            } else {
                bodyFromForm.spinner().start();
                $('form.registration').trigger('login:register', e);

                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: function (data) {
                        bodyFromForm.spinner().stop();
                        if (!data.success) {
                            formValidation(form, data);
                        } else {
                            location.href = data.redirectUrl;
                        }
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                        }

                        bodyFromForm.spinner().stop();
                    }
                });
            }

            return false;
        });
    },

    resetPassword: function () {
        $('.reset-password-form').on('submit', function (e) {
            e.preventDefault();

            var form = $(this),
                bodyFromForm = form.parents('body'),
                url = form.attr('action');

            bodyFromForm.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    bodyFromForm.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body').empty()
                            .append('<p>' + data.receivedMsgBody + '</p>');
                        // if (!data.mobile) {
                        $('.submitEmailButton').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        $('.submitEmailButton').on('click', function (e) {
                            e.preventDefault();
                            window.location.reload();
                        });

                        if (data.mobile) {
                            $('.send-email-btn').empty()
                                .html('<a href="'
                                    + data.returnUrl
                                    + '" class="btn btn-primary btn-block">'
                                    + data.buttonText + '</a>'
                                );
                        }
                    }
                },
                error: function () {
                    bodyFromForm.spinner().stop();
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    }
};
